import * as React from "react";
import { UserAvatar } from "frontend-components/components/ui/user-avatar";
import type { ReactionUser } from "frontend-components/lib/reactions";

interface ReactionUserListItem {
    user: ReactionUser;
    emoji?: string;
}

function ReactionUserList({
    items,
    getUserAvatarUrl,
}: {
    items: readonly ReactionUserListItem[];
    getUserAvatarUrl?: (user: ReactionUser) => string | undefined;
}) {
    return (
        <ul className="flex flex-col gap-1">
            {items.map(({ user, emoji }) => {
                const fullName = `${user.firstName} ${user.lastName}`;
                const avatarUrl = getUserAvatarUrl?.(user);

                return (
                    <li key={user.id} className="flex h-9 items-center gap-2 rounded-[3px] px-2">
                        <UserAvatar
                            aria-hidden="true"
                            className="size-7"
                            userId={user.id}
                            firstName={user.firstName}
                            lastName={user.lastName}
                            src={avatarUrl}
                        />
                        <span className="min-w-0 flex-1 truncate" title={fullName}>
                            {fullName}
                        </span>
                        {emoji && (
                            <span aria-hidden="true" className="shrink-0 text-body-base">
                                {emoji}
                            </span>
                        )}
                    </li>
                );
            })}
        </ul>
    );
}

function ReactionUserListContainer({ children }: { children: React.ReactNode }) {
    return (
        <div className="max-h-[13.5rem] overflow-y-auto pt-2 pr-1 [scrollbar-width:thin] [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-compendia-border [&::-webkit-scrollbar-track]:bg-transparent">
            {children}
        </div>
    );
}

export { ReactionUserList, ReactionUserListContainer };
export type { ReactionUserListItem };
